export default `---
slug: luxembourg
country: Luxembourg
countryCode: LUX
continent: Europe
year: 2023
title: "Luxembourg"
description: "The tiny grand duchy — surprisingly beautiful for a country you can drive across in an hour."
thumbnail: /images/travels/LUX/lux_thumb.jpg
relatedLinks: []
---
![luxembourg](/images/travels/LUX/lux_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Luxembourg and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
